import { Button, Stack, Typography } from '@mui/joy';
import HalfHourTimeInput from '../ui/HalfHourTimeInput';
import { modeValues, normalizeTime } from './schedule';

export default function ScheduleTimeFields({value, onChange, label = 'Время прибытия', disabled = false}) {
  const current = normalizeTime(value);
  return <Stack spacing={1} sx={{minWidth: 0}}>
    <Stack role="group" aria-label={label} direction="row" gap={0.5} flexWrap="wrap">
      {[['any', 'Любое время'], ['exact', 'Точное время'], ['window', 'Интервал']].map(([mode, title]) =>
        <Button key={mode} size="sm" variant={current.mode === mode ? 'soft' : 'plain'} disabled={disabled}
          aria-pressed={current.mode === mode} onClick={() => onChange(modeValues(mode, current))} sx={{minHeight: 30, borderRadius: 'sm'}}>{title}</Button>)}
    </Stack>
    {current.mode !== 'any' && <Stack direction="row" spacing={1} alignItems="center" sx={{minWidth: 0}}>
      <HalfHourTimeInput label={`${label}${current.mode === 'window' ? ' с' : ''}`} value={current.time_from}
        onChange={time => onChange({...current, time_from: time, ...(current.mode === 'exact' ? {time_to: time} : {})})}
        disabled={disabled} sx={{flex: 1, minWidth: 0}}/>
      {current.mode === 'window' && <><Typography level="body-sm">—</Typography>
        <HalfHourTimeInput label={`${label} до`} value={current.time_to} onChange={time => onChange({...current, time_to: time})}
          disabled={disabled} sx={{flex: 1, minWidth: 0}}/></>}
    </Stack>}
    <Typography level="body-xs" sx={{color: 'text.tertiary'}}>
      {current.mode === 'exact' ? 'Специалисту нужно прибыть к указанному времени.' : current.mode === 'window'
        ? 'Специалист может прибыть в любой момент этого интервала; это не длительность замера.' : 'Время прибытия можно выбрать позже при согласовании.'}
    </Typography>
  </Stack>;
}
